import { Component } from '@angular/core';
import { OrderService } from '../services/order.service';
import { IOrder } from '../models/orders/order';
import Chart, { ChartData, ChartOptions } from 'chart.js/auto';
import { CommonMethods } from '../common-methods';
import { Router } from '@angular/router';
// import { SalesChartComponent } from './sales-chart/sales-chart.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {


  views: string[] = ['Monthly', 'Quaterly', 'Yearly'];
  currentView: string = 'Monthly';
  selectedYear: number = new Date().getFullYear();
  availableYears: number[] = [2023, 2024, 2025];

  // Update view and year based on user selection
  updateView(view: string): void {
    this.currentView = view;
    this.createChartWithView();
  }

  updateYear(year: number): void {
    this.selectedYear = year;
    this.createChartWithView();
  }

  order: any
  part: any
  inprogessJob:any;
  completedJob:any;
  totalJob:any;
  orders: IOrder[] = [];


  barChart:any;
  doubleLineChart:any;
  pieChart:any;
  lineChart:any;

  constructor(private orderService: OrderService,
    private _router: Router
  ){}

  // selectView(view: any){
  //   this.currentView = view;
  //   // this.salesChartComponent.fetchData();
  // }

 data:any;

  createChartWithView(){
    // let data;
      if(this.currentView === 'Monthly'){
        this.data = this.getMonthlyData(this.selectedYear) || [];
      } else if(this.currentView === 'Quaterly'){
        this.data = this.getQuaterData(this.selectedYear) || [];
      } else{
        this.data = this.getYearData(this.selectedYear) || [];
      }
      this.barChart = this.loadChart(this.barChart, 'jobChart1', 'bar', 'bar', this.data.barChart);
      this.lineChart = this.loadChart(this.lineChart, 'salesChart1', 'line', 'line', this.data.lineChart);
      this.doubleLineChart = this.loadChart(this.doubleLineChart, 'doubleChart1', 'line', 'doubleLine', this.data.doubleLine);
      this.pieChart = this.loadChart(this.pieChart, 'pieChart1', 'pie', 'pie', this.data.pieChart);
      console.log("this.bar: ", this.doubleLineChart);
      console.log("this.lineChart data: ", this.data.doubleLine);
      
  }

  ngAfterViewInit() {
    // for redirect to summay page for this role
    if(CommonMethods.getItem("role")==="FAVORITE"){
      this._router.navigate(["order-summary"]);
    }
    this.createChartWithView();
  }

  loadChart(chart: any, chartHtmlElementName: string, chartType: any, chartDataType: any, chartData:any) {
    const ctx = document.getElementById(chartHtmlElementName) as HTMLCanvasElement;
    if (chart) {
      chart.destroy(); // Destroy existing chart before reloading
    }


    // let data = this.getChartData(this.view, this.selectedYear);
    let data = this.getChartData(chartDataType, chartData);

    return new Chart(ctx, {
      type: chartType,
      data: data,
      options: this.getChartOptions(chartDataType),
    });
  }

  getChartData(chartType:any, dataset: any): ChartData {
    if(chartType === 'pie'){
      return this.getPieChartData(dataset);
    } else if(chartType === 'line'){
      return this.getTotalSalesChartData(dataset);
    }else if(chartType === 'doubleLine'){
      return this.getPartSalesChartData(dataset);
    } else { 
      return this.getBarChartData(dataset);
    }
  }

  getPieChartData(dataset:any){
    return {
      labels: dataset.labels,
      datasets: [
        {
          data: [dataset.services, dataset.partSell],
          backgroundColor: ['#4CAF50', '#FFC107'],
          hoverOffset: 4,
        },
      ],
    }
  }
  
  getTotalSalesChartData(dataset:any){
    return {
      labels: dataset.labels,
      datasets: [
        {
          data: dataset.sales,
          borderColor: '#4f46e5',
          backgroundColor: 'rgba(79, 70, 229, 0.2)',
          fill: true,
          tension: 0.4,
        },
      ],
    };
  }

  getPartSalesChartData(dataset:any){
    return {
      labels: dataset.labels, // Dynamic labels
      datasets: [
        {
          label: 'Part Buy',
          data: dataset.partBuyData, // Dynamic data for Part Buy
          borderColor: '#ffc107',
          fill: false,
          tension: 0.3,
        },
        {
          label: 'Part Sell',
          data: dataset.partSellData, // Dynamic data for Part Sell
          borderColor: '#4f46e5',
          fill: false,
          tension: 0.3,
        },
      ],
    };
  }

  getBarChartData(dataset:any){
    return {
      labels: dataset.labels,
      datasets: [
        {
          label: 'Pending',
          data: dataset.pending,
          backgroundColor: '#FFC107',
          borderWidth: 1,
        },
        {
          label: 'In Progress',
          data: dataset.inProgress,
          backgroundColor: '#17A2B8',
          borderWidth: 1,
        },
        {
          label: 'Complete',
          data: dataset.complete,
          backgroundColor: '#28A745',
          borderWidth: 1,
        },
        {
          label: 'Canceled',
          data: dataset.canceled,
          backgroundColor: '#DC3545',
          borderWidth: 1,
        },
      ],
    };
  }

  getChartOptions(chartType: any): ChartOptions {
    if(chartType === 'pie'){
      return this.getPieChartOption();
    } else if(chartType === 'line'){
      return this.getLineChartOption();
    }else if(chartType === 'doubleLine'){
      return this.getDoubleLineChartOption();
    } else{
      return this.getBarChartOption();
    }
  }



  getPieChartOption(): ChartOptions{
    return {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem: any) => {
              const value = tooltipItem.raw;
              const total = tooltipItem.dataset.data.reduce((a: number, b: number) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(2);
              return `${tooltipItem.label}: ${percentage}%`;
            },
          },
        },
      },
    };
  }

  getLineChartOption(): ChartOptions{
    return {
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          display: true,
        },
        y: {
          display: true,
        },
      },
    };
  }

  getDoubleLineChartOption(): ChartOptions{
    return {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
      },
    };
  }

  getBarChartOption(): ChartOptions {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
      },
      scales: {
        x: {
          grid: {
            drawOnChartArea: false,
            drawTicks: true,
          },
          border: {
            display: true,
          },
        },
        y: {
          beginAtZero: true,
          grid: {
            color: 'rgba(200, 200, 200, 0.3)',
          },
          border: {
            display: true,
          },
        },
      },
    };
  }

  getMonthlyData(year:any){
    if(year == 2025){
      return {
        doubleLine: {
          labels: [
            'Jan', 'Feb', 'Mar'
          ],
          partBuyData: [50, 70, 60],
          partSellData: [40, 65, 55],
        },
        barChart: {
          "year": 2025,
          "labels": ["January", "February", "March"],
          "pending": [12, 10, 12],
          "inProgress": [7, 5, 8],
          "complete": [11, 12, 13],
          "canceled": [2, 1, 0]
        },
        lineChart: {
          totalAmount: 113200,
          dateRange: "January - March",
          year: 2025,
          labels: ["Jan", "Feb", "Mar"],
          sales: [610, 570, 590]
        },
        pieChart: {
          "year": 2025,
          labels: ['Service Charges', 'Part Sales'],
          services: 6200,
          partSell: 3600
        }
      }
    } else if(year == 2024){
      return {
        doubleLine: {
          labels: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
          partBuyData: [150, 70, 160, 80, 90, 100, 110, 95, 85, 120, 130, 140],
          partSellData: [40, 165, 55, 175, 85, 195, 105, 185, 75, 115, 125, 135],
        },
        barChart: {
          "year": 2024,
          "labels": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          "pending": [22, 11, 11, 9, 10, 12, 9, 12, 10, 9, 8, 11],
          "inProgress": [9, 5, 6, 4, 6, 4, 6, 8, 5, 4, 5, 7],
          "complete": [12, 12, 15, 13, 10, 9, 11, 13, 12, 10, 9, 14],
          "canceled": [6, 0, 3, 2, 1, 0, 1, 3, 2, 1, 0, 2]
        },
        lineChart: {
          totalAmount: 613200,
          dateRange: "January - December",
          year: 2024,
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          sales: [620, 570, 590, 500, 490, 520, 600, 620, 520, 540, 490, 520]
        },
        pieChart: {
          "year": 2024,
          labels: ['Service Charges', 'Part Sales'],
          services: 5800,
          partSell: 6900
        }
      }
    } else{
      return {
        doubleLine: {
          labels: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
          partBuyData: [120, 70, 100, 80, 90, 100, 150, 95, 85, 120, 130, 140],
          partSellData: [40, 165, 55, 175, 85, 95, 105, 105, 75, 115, 125, 135],
        },
        barChart: {
          "year": 2023,
          "labels": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          "pending": [12, 10, 11, 9, 8, 6, 7, 12, 10, 9, 8, 11],
          "inProgress": [7, 5, 6, 4, 5, 4, 6, 8, 5, 4, 5, 7],
          "complete": [14, 12, 15, 13, 10, 9, 11, 13, 12, 10, 9, 14],
          "canceled": [2, 1, 3, 2, 1, 0, 1, 3, 2, 1, 0, 2]
        },
        lineChart: {
          totalAmount: 313200,
          dateRange: "January - December",
          year: 2023,
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          sales: [210, 470, 590, 400, 490, 520, 600, 620, 520, 540, 490, 520]
        },
        pieChart: {
          "year": 2023,
          labels: ['Service Charges', 'Part Sales'],
          services: 4500,
          partSell: 2300
        }
      }
    }
  }

  getQuaterData(year:any){
    if(year == 2025){
      return {
        doubleLine: {
          labels: ['Q1'],
          partBuyData: [180],
          partSellData: [170],
        },
        barChart: {
          "year": 2025,
          "labels": ["Q1"],
          "pending": [42],
          "inProgress": [12],
          "complete": [24],
          "canceled": [12]
        },
        lineChart: {
          "totalAmount": 14000,
          "dateRange": "Q1",
          "year": 2025,
          "labels": ["Q1"],
          "sales": [14000]
        },
        pieChart: {
          "year": 2025,
          labels: ['Service Charges', 'Part Sales'],
          services: 19000,
          partSell: 10000
        }
      }
    } else if(year == 2024){
      return {
        doubleLine: {
          labels: ['Q1', 'Q2', 'Q3', 'Q4'],
          partBuyData: [220, 210, 240, 260],
          partSellData: [170, 200, 230, 250],
        },
        barChart: {
          "year": 2024,
          "labels": ["Q1", "Q2", "Q3", "Q4"],
          "pending": [32, 49, 34, 26],
          "inProgress": [12, 24, 35, 24],
          "complete": [34, 43, 50, 79],
          "canceled": [10, 5, 1, 10]
        },
        lineChart: {
          "totalAmount": 700000,
          "dateRange": "Q1 - Q4",
          "year": 2024,
          "labels": ["Q1", "Q2", "Q3", "Q4"],
          "sales": [14000, 17000, 15000, 24000]
        },
        pieChart: {
          "year": 2024,
          labels: ['Service Charges', 'Part Sales'],
          services: 27000,
          partSell: 9700
        }
      }
    } else{
      return {
        doubleLine: {
          labels: ['Q1', 'Q2', 'Q3', 'Q4'],
          partBuyData: [180, 210, 240, 260],
          partSellData: [170, 200, 230, 250],
        },
        barChart: {
          "year": 2023,
          "labels": ["Q1", "Q2", "Q3", "Q4"],
          "pending": [42, 69, 34, 26],
          "inProgress": [22, 14, 45, 34],
          "complete": [54, 73, 30, 59],
          "canceled": [12, 2, 11, 20]
        },
        lineChart: {
          "totalAmount": 32000,
          "dateRange": "Q1 - Q4",
          "year": 2023,
          "labels": ["Q1", "Q2", "Q3", "Q4"],
          "sales": [5000, 8000, 7000, 12000]
        },
        pieChart: {
          "year": 2023,
          labels: ['Service Charges', 'Part Sales'],
          services: 13000,
          partSell: 8700
        }
      }
    }
  }

  getYearData(year:any){
    const data = {
      doubleLine: {
        labels: ['2021', '2022', '2023', '2024', '2025'],
        partBuyData: [1200, 1300, 1400, 1500, 1600],
        partSellData: [1100, 1250, 1350, 1450, 1550],
      },
      barChart: {
        year: 2025,
        labels: ["2025", "2024", "2023"],
        pending: [42, 250, 112],
        inProgress: [12, 325, 128],
        complete: [24, 412, 130],
        canceled: [12, 80, 50],
      },
      lineChart: {
        totalAmount: 3528000,
        dateRange: "2022 - 2025",
        labels: ['2022', '2023', '2024', '2025'],
        sales: [1200, 1500, 1100, 1600],
      },
      pieChart: {}  // Empty, will be updated based on year
    };
  
    // Handle pieChart data based on the year
    if (year == 2025) {
      data.pieChart = {
        year: 2025,
        labels: ['Service Charges', 'Part Sales'],
        services: 34000,
        partSell: 38000
      };
    } else if (year == 2024) {
      data.pieChart = {
        year: 2024,
        labels: ['Service Charges', 'Part Sales'],
        services: 97000,
        partSell: 68000
      };
    } else {
      data.pieChart = {
        year: 2023,
        labels: ['Service Charges', 'Part Sales'],
        services: 45000,
        partSell: 33000
      };
    }
  
    return data;
  }
}
